<template>

	<div class="g-display-list-filtering__item g-display-list-filtering__per-page">
		<fieldset>
			<legend class="u-hide-visually">Number of Products to Show</legend>
			<ul class="g-form-list">
				<li class="g-form-list__item">
					<div class="g-form-label">View</div>
					<div class="g-display-list-per-page__options">
						<label class="g-display-list-per-page__option" v-for="option in perPage" :key="option.value" :title="`Show ${option.label} per page`">
							<input class="g-form-checkbox__input" type="radio" v-model="selectedPerPage" :value="option.value" />
							<span class="g-display-list-per-page__caption">{{option.label}}</span>
						</label>
					</div>
				</li>
			</ul>
		</fieldset>
		<!-- <ul class="g-form-list" v-if="pagination">
			<li class="g-form-list__item">
				<label class="g-form-label" :for="'l-per_page' + labelUid">View</label>
				<div class="g-form-select">
					<select v-model="selectedPerPage" :id="'l-per_page' + labelUid" class="g-form-select__dropdown-display">
						<option v-for="option in perPage" :key="option" :value="option">
							{{ option }} Items/Page
						</option>
					</select>
				</div>
			</li>
		</ul> -->
	</div>

	<!--

		<fieldset>
				<legend class="u-hide-visually">Number of Products to Show</legend>
				<input type="hidden" name="Search" value="%">
				<input type="hidden" name="Sort_By" value="disp_order">
				<ul class="g-form-list">
					<li class="g-form-list__item">
						<div class="g-form-label">View</div>
						<div class="g-display-list-per-page__options">
							<label class="g-display-list-per-page__option" title="20">
								<input class="g-form-checkbox__input" type="radio" name="Per_Page" value="20"
									onchange="MMProdList_UpdateQuery( this ); return true;">
								<span class="g-display-list-per-page__caption">20</span>
							</label>
							<label class="g-display-list-per-page__option" title="40">
								<input class="g-form-checkbox__input" type="radio" name="Per_Page" value="40"
									onchange="MMProdList_UpdateQuery( this ); return true;">
								<span class="g-display-list-per-page__caption">40</span>
							</label>
							<label class="g-display-list-per-page__option" title="All">
								<input class="g-form-checkbox__input" type="radio" name="Per_Page" value="-1"
									onchange="MMProdList_UpdateQuery( this ); return true;">
								<span class="g-display-list-per-page__caption">All</span>
							</label>
						</div>
					</li>
				</ul>
			</fieldset>

	 -->

</template>

<script>

	import Search from '../../Search';

	export default {
		data() {
			return {
				perPage: [
					{
						label: 60,
						value: 60
					},
					{
						label: 80,
						value: 80
					},
					{
						label: 100,
						value: 100
					}
				],
				selectedPerPage: 60
			}
		},
		props: {
			pagination: {
				default() {
					return {}
				}
			}
		},
		watch: {
			selectedPerPage( perPage, previous ) {

				if ( previous == null ) {
					return;
				}

				Search.client
					.perPage( perPage )
					.search();

			}
		}
	}

</script>
